import { CountryInformationService } from './../../@core/mock/country-information.service';
import { NgModule } from '@angular/core';
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbTabsetModule,
  NbUserModule,
  NbRadioModule,
  NbSelectModule,
  NbListModule,
  NbIconModule,
  NbStepperModule,
  NbWindowModule,
} from '@nebular/theme';
import { NgxEchartsModule } from 'ngx-echarts';
import { ThemeModule } from '../../@theme/theme.module';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountryContentComponent } from './country-content.component';
import { StepperComponent } from './stepper/stepper.component';
import { TabsComponent } from './tabs/tabs.component';
import { HttpClient } from '@angular/common/http';
import { CountryInformationsComponent } from './country-informations/country-informations.component';
import { CountryPicturesComponent } from './tabs/country-pictures/country-pictures.component';
import { LeafletComponent } from './tabs/gmaps/gmaps.component';
import { AgmCoreModule } from '@agm/core';

@NgModule({
  imports: [
    FormsModule,
    ThemeModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbTabsetModule,
    NbActionsModule,
    NbRadioModule,
    NbSelectModule,
    NbListModule,
    NbIconModule,
    NbButtonModule,
    NbWindowModule,
    NgxEchartsModule,
    LeafletModule,
    NbStepperModule,
    ReactiveFormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCpsrNrz0vvsWpw0QNfcwyFH1Jmvsg72BY',
      libraries: ['places'],
    }),
  ],
  declarations: [
    CountryContentComponent,
    StepperComponent,
    TabsComponent,
    CountryInformationsComponent,
    CountryPicturesComponent,
    LeafletComponent,
  ],
  providers: [
    HttpClient,
    CountryInformationService,
  ],
})
export class CountryContentModule { }
